import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './screens/Login/login';
import Dashboard from './screens/Dashboard/dashboard';
import Career from './screens/Career/career';
import News from './screens/News/news';
import Awards from './screens/Awards/awards';
import ChangePassword from './screens/ChangePassword/changePassword';
import AdminLayout from './layouts/adminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import Journey from './screens/Journey/journey';
import CSRPage from './screens/CSR/csr';
import Management from './screens/Management/management';
import InvestorDoc from './screens/InvestorDocument/investorDocument';
import GovernmentDoc from './screens/GovernmentDocument/governmentDocument';
import Banner from './screens/Banner/banner';
import Profile from './screens/Profile/profile';
import CategoryCareer from './screens/Career/Category Career/categoryCareer';
import ApplicationJobs from './screens/Career/Application Jobs/applicationJobs';



class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.error("Caught by Error Boundary:", error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return <h2>Something went wrong.</h2>;
    }
    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="banner" element={<Banner />} />
            <Route path="career" element={<Career />} />
            <Route path="category-career" element={<CategoryCareer />} />
            <Route path="application-jobs" element={<ApplicationJobs />} />
            {/* <Route path="article" element={<Article />} /> */}
            <Route path="news" element={<News />} />
            <Route path="awards" element={<Awards />} />
            <Route path="journey" element={<Journey />} />
            <Route path="profile" element={<Profile />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="CSR" element={<CSRPage />} />            
            <Route path="management" element={<Management />} />            
            <Route path="investor-doc" element={<InvestorDoc />} />            
            <Route path="government-doc" element={<GovernmentDoc />} />            
            {/* Add other nested routes here: career, article, users */}
          </Route>
          {/* Optionally add a catch-all route or redirect */}
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
